var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 337,
    viewBox: "0 0 275 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2487_30720)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2487_30720)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 263,
    height: 325,
    rx: 2,
    fill: "#F1EEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 24.06C24 22.9223 24.9223 22 26.06 22L248.94 22C250.078 22 251 22.9223 251 24.06L251 142L24 142L24 24.06Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 154,
    width: 219,
    height: 15,
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 173,
    width: 173,
    height: 15,
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 198,
    width: 115,
    height: 22,
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 249.5,
    width: 102,
    height: 53,
    rx: 1.5,
    stroke: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 270,
    r: 11,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 286,
    width: 79,
    height: 8,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5 271C177.5 281.217 169.217 289.5 159 289.5C148.783 289.5 140.5 281.217 140.5 271C140.5 260.783 148.783 252.5 159 252.5C169.217 252.5 177.5 260.783 177.5 271Z",
    stroke: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 271,
    r: 11,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 295,
    width: 42,
    height: 8,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.25 252.01C220.714 251.742 221.286 251.742 221.75 252.01L237.07 260.856C237.535 261.124 237.82 261.619 237.82 262.155V279.845C237.82 280.381 237.535 280.876 237.07 281.144L221.75 289.99C221.286 290.258 220.714 290.258 220.25 289.99L204.929 281.144C204.465 280.876 204.179 280.381 204.179 279.845V262.155C204.179 261.619 204.465 261.124 204.929 260.856L220.25 252.01Z",
    stroke: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 271,
    r: 11,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 295,
    width: 42,
    height: 8,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 323H269V331H6V323Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2487_30720)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2487_30720)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 16,
    width: 42,
    height: 42,
    rx: 21,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.8 28H236.2V35.2H229V38.8H236.2V46H239.8V38.8H247V35.2H239.8V28Z",
    fill: "#C5C5C5"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2487_30720",
    x: 0,
    y: 0,
    width: 275,
    height: 337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2487_30720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2487_30720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2487_30720",
    x: 203.025,
    y: 2.02455,
    width: 69.9509,
    height: 69.9509,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.98773
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2487_30720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2487_30720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2487_30720"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 263,
    height: 325,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2487_30720"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 16,
    width: 42,
    height: 42,
    rx: 21,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProducts);
export default __webpack_public_path__ + "static/media/noProducts.ea2011ceffd2aca46756469bc40b0360.svg";
export { ForwardRef as ReactComponent };